export const ACCESS_TOKEN = 'accessToken';

export const COLORS = {
  WHITE: '#ffffff',
  GRAY100: '#D0D5DD',
  SECONDARY: '#5532FA',
};

export const NETWORK_ERROR = 'Network Error';
export const ERROR_STATUS_500 = 5;
export const ERROR_STATUS_401 = 401;
export const ERROR_STATUS_404 = 404;
export const ERROR_MESSAGE = 'Something went wrong!';

export const CHATBOT_ROLE = {
  USER: 'user',
  ASSISTANT: 'assistant',
};

export const FIELD_TYPES = {
  UPLOAD: 'upload',
  NUMBER: 'number',
  DROPDOWN: 'dropdown',
  FILE: 'file',
  TEL: 'tel',
  EMAIL: 'email',
};

export const MAX_FILE_SIZE = 10 * 1024 * 1024;

export const MAX_LENGTH_LIMIT = 100;

export const DELETED = 'DELETED';

export const CHAT_WINDOW_OFFSET = 68;

export const PREVIEW_OFFSET = 50;

export const MOBILE_BREAKPOINT = 576;

export const CHATBOT_FAQ_PADDING = 200;

export const VALIDATION_MESSAGES = {
  REQUIRED: 'This field is required',
  INVALID_EMAIL: 'Invalid email format',
  NUMERIC_ONLY: 'Only numbers allowed',
  FILE_TOO_LARGE: 'File too large. Max 10MB allowed.',
  UPLOAD_ERROR: 'Error occurred while uploading file.',
  SUBMISSION_ERROR: 'Something went wrong during submission.',
  SUBMISSION_SUCCESS: 'Thank you for your submission!',
  DUPLICATE_FILE: 'Duplicate files are not allowed!',
};

export const INACTIVE = 'INACTIVE';

export const DATE_FORMAT = {
  STANDARD_TIME: 'HH:mm',
};

export const FIELD_OPTIONAL_TEXT = '(Valinnainen)';
